module.exports = __webpack_public_path__ + "img/1000.bad57c51.jpg";